import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { DTPCoreModule } from './core.module';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from 'shared/shared.module';
import { AppComponent } from './app.component';
import { AuthCallbackComponent } from './auth-callback.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ErrorComponent } from './error/error.component';
import { AppContentComponent } from './app-content/app-content.component';
import { EnvService } from '../env/env.service';
import { ThemeService } from 'ng2-charts';

@NgModule({
  declarations: [
    AppComponent,
    AppContentComponent,
    ErrorComponent,
    AuthCallbackComponent,
    LandingPageComponent,
    AuthCallbackComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    DTPCoreModule,
    AppRoutingModule
  ],
  providers: [
    Title,
    EnvService,
    ThemeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}